export default "__VITE_ASSET__S$OCwKZD__"